import { Component, OnInit } from '@angular/core';
import { Bpgs, Interests, Skills, MembershipFormData, Leadership, LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';

@Component({
    selector: 'app-bpg-site',
    templateUrl: './bpg-site.component.html',
    styleUrls: ['./bpg-site.component.css']
})

export class BpgSiteComponent implements OnInit {
    selectedSite: any;
    bpgList: Bpgs[] = [];
    savedData: any = JSON.parse(sessionStorage.getItem('MembershipData'));
    formData: MembershipFormData[];
    interestList: Interests[];
    skillsList: Skills[];
    leadershipList: Leadership = new Leadership();
    message: string;
    demographicsList: any[] = [];
    otherSKills: string;
    membershipDetails: any[] = [];
    userId = 1;
    loginData: any = JSON.parse(localStorage.getItem('loginData'));
    loginUserId: any[] = [];
    savedMembershipForm: any;
    landingDTOModel: LandingDTOModel = new LandingDTOModel();
    siteId1: any = localStorage.getItem('userSiteId');
    filter: FilterModel = new FilterModel();
    timeOutError: boolean;
    timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
    nositefound = false;
    siteList: any[] = [];
    defaultSite: string;
    virtualBpg: boolean;

    corporateType: string;
    isCorporateUser = false;

    /**
     * @class BpgSiteComponent
     * @constructor
     */
    constructor(
        private readonly router: Router,
        private readonly spinnerService: Ng4LoadingSpinnerService,
        
        private readonly environment: EnvironmentConfiguration,
        private readonly bpgCommonService: BpgCommonService) { }

    ngOnInit() {
        localStorage.setItem('oneSkill', 'false');
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
                    if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

                this.router.navigate(['/log-out']);
            }
        }
        window.scrollTo(0, 0);
        localStorage.removeItem('searchedEventsCaledarItems');
        this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
        if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
            this.isCorporateUser = true;
        }
        this.formData = [];
        if (this.savedData === null) {
            this.savedData = "default msg"
        }
        if (this.loginData !== undefined) {
            this.defaultSite = this.loginData.site.siteName;
        }

        this.spinnerService.show();

        if (this.savedData[0].siteFormData !== undefined) {
            this.selectedSite = this.savedData[0].siteFormData;
        } else {
            this.selectedSite = undefined;
        }
        this.bpgList = [];
        if (this.savedData[0].interestFormData !== undefined) {
            this.interestList = this.savedData[0].interestFormData;
        } else {
            this.interestList = [];
        }
        if (this.savedData[0].skillsFormData !== undefined) {
            this.skillsList = this.savedData[0].skillsFormData;
        } else {
            this.skillsList = [];
        }
        if (this.savedData[0].leadershipFormData !== undefined) {
            this.leadershipList = this.savedData[0].leadershipFormData;
        } else {
            this.leadershipList = null;
        }
        if (this.savedData[0].otherSkillsFormData !== undefined) {
            this.otherSKills = this.savedData[0].otherSkillsFormData;
        } else {
            this.otherSKills = null;
        }
        this.bpgCommonService.getSiteList(this.landingDTOModel).subscribe(data => {
            this.siteList = data;
            const menu = [];
            for (const d of data) {
                if (d.siteName !== "DEFAULT") {
                    d.checked = false;
                    d.isRegistered = false;
                    if (this.selectedSite !== undefined) {
                        if (d.siteName === this.selectedSite.siteName) {
                            d.checked = true;
                        }
                    }
                    menu.push(d);
                }
            }
            this.siteList = menu;
            this.spinnerService.hide();
            this.bpgCommonService.getRegisteredSiteList(this.loginData.userId).subscribe(data => {
                const registeredSites = data;

                registeredSites.forEach(elt => {
                    for (const site of this.siteList) {
                        if (site.siteId === elt) {
                            site.isRegistered = true;
                        }
                    }
                });

            }, err => {
                this.spinnerService.hide();
                if (err.statusText === ConstantValues.unknownError) {
                    this.timeOutError = true;
                }
            });
        }, err => {
            this.spinnerService.hide();
            this.nositefound = true;
            if (err.statusText === ConstantValues.unknownError) {
                this.timeOutError = true;
            }
        });
    }

    /** To send data to next page
     * @class BpgSiteComponent
     * @method sendData
     */
    public sendData() {
        if (this.selectedSite === undefined || this.selectedSite === null || this.selectedSite === '') {
            this.message = "*Please select a site";
            return
        }
        this.virtualBpg = this.defaultSite !== this.selectedSite.siteName
        this.formData.push({ virtualBpg: this.virtualBpg, siteFormData: this.selectedSite, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
        sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
        this.router.navigate(['membership/erg']);
        window.scrollTo(0, 0)
    }

    /** to select the checkbox
     * @class BpgSiteComponent
     * @method toggleRadio
     */
    toggleRadio(event, data) {
        if (event.target.checked) {
            this.selectedSite = (data);
            this.virtualBpg = this.defaultSite !== data.siteName;
        }

    }

}
